"use strict";

module.exports = require("./Bottleneck");


//////////////////
// WEBPACK FOOTER
// ./~/bottleneck/lib/index.js
// module id = 94Ke
// module chunks = 1